import { Stack } from '@mantine/core';
import type { FC } from 'react';

import { TextInput } from '../../components/reactHookFormMantine/TextInput';
import { useI18n } from '../../hooks/useI18n.ts';
import type { FormInputsContent } from '../FormInputsContent.ts';
import type { FormEmail } from './schema';

export const Email: FC<FormInputsContent<FormEmail>> = ({ useFormValue: { control } }) => {
  const { t } = useI18n();

  return (
    <Stack>
      <TextInput
        autoComplete="email"
        control={control}
        label={t('signup_label--email-address') ?? 'Email address'}
        name="email"
        placeholder={t('signup_placeholder--email-address') ?? 'example@emailaddress.com'}
        type="email"
      />
    </Stack>
  );
};
